import { CardHeader } from "components";
import { Step } from "helpers";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AuthPasswordRecoverForm } from "./components/AuthPasswordRecoverForm";
import { useTranslation } from "react-i18next";

interface AuthPasswordRecoverProps {
  email: string;
  code?: string;
}

export const AuthPasswordRecover = ({ email, code }: AuthPasswordRecoverProps) => {
  const [step, setStep] = useState<Step>(0);
  const [title, setTitle] = useState<string>("");
  const [paragraph, setParagraph] = useState<string>("");
  const { t, i18n } = useTranslation();

  useEffect(() => {
    if (step === 0) {
      setTitle(t("auth.recoverPassword"));
      setParagraph(t("auth.recoverPasswordDesc"));
    } else {
      setTitle(t("auth.passwordChanged"));
      setParagraph("");
    }
  }, [step, i18n.language]);

  return (
    <>
      <CardHeader title={title} paragraph={paragraph} withLanguage={step === 0} />
      {step === 0 ? (
        <AuthPasswordRecoverForm email={email} code={code} setStep={setStep} />
      ) : (
        <Link to="/" className="mt-7">
          {t("common.signInToParkber")}
        </Link>
      )}
    </>
  );
};
